import { useEffect, useState } from 'react'
import { manageImageCache } from '../editar-perfil/_utils/imageCompression'

export function useImageWithCache(mode: string, fallbackUrl: string) {
	const [imageUrl, setImageUrl] = useState(fallbackUrl)

	useEffect(() => {
		// Check cache after component mounts (works on both navigation and page reload)
		const cached = manageImageCache.load({ mode })
		if (cached) {
			console.log(`Loading ${mode} from cache:`, `${cached.slice(0, 50)}...`)
			setImageUrl(cached)
		}
	}, [mode])

	return [imageUrl, setImageUrl] as const
}
